import React from 'react'
import { Helmet } from 'react-helmet'

interface Props {
  title: string
}

const Page: React.FC<Props> = ({ title, children }) => (
  <>
    <Helmet>
      <title>{title} - Functions - Segment</title>
    </Helmet>

    {children}
  </>
)

export default Page
